import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	newLabel: {
		id: 'software-reports.overview.list.item.new-label',
		defaultMessage: 'New',
		description: 'Label to say that this is a new feature',
	},
	learnMore: {
		id: 'software-reports.overview.list.item.learn-more',
		defaultMessage: 'Learn more',
		description:
			'Learn more hyperlink takes users to a page guiding them through setting up CI/CD pipelines.',
	},
});

export default messages;
